var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let CheckboxNodeInput = class CheckboxNodeInput extends LitElement {
    handleInputChange(event) {
        this.input.value = event.detail;
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: {
                key: this.key,
                input: this.input,
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <simple-checkbox
                .checked=${this.input?.value || false}
                .label=${this.input.placeholder || msg('Checkbox', { id: 'nodeInput.label.checkbox', desc: 'Checkbox node input default label' })}
                @checkbox-change=${this.handleInputChange}
            ></simple-checkbox>
        `;
    }
};
__decorate([
    property({ type: String })
], CheckboxNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], CheckboxNodeInput.prototype, "input", void 0);
CheckboxNodeInput = __decorate([
    localized(),
    customElement('checkbox-node-input')
], CheckboxNodeInput);
export { CheckboxNodeInput };
//# sourceMappingURL=CheckboxNodeInput.js.map